// browser-based parsing of urls
// parseUrl :: String -> DOM Object
export const parseUrl = (_url) => {
  const url = document.createElement('a');
  url.href = _url;
  return url;
};

// noTrailingSlash :: String -> String
export const noTrailingSlash = (str) => str.replace(/\/$/, '');

// parseUrl uses the DOM/browser to sanitize urls, making these all more consistent
// stripSlash :: String -> String
export const stripSlash = (str = '') =>
  noTrailingSlash(parseUrl(String(str)).pathname);
